import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import React, { useEffect, useState } from 'react'
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { useGetAllActiveUsersQuery, useGetSaleInfoByIdQuery, useLazyGetSaleInfoByIdQuery, useUpsertSaleInfoDetailsMutation } from '../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { initialValuesSale } from '../../Projects/SaleWizardData/InitialValuesSalesWizard';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { CSVLink } from 'react-csv';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';


const FinancialPayment = ({ getallActiveUsers, setSaleInfoData, projectId, projectLookups, setTotalAmount }: any) => {

    const [paymentType, setPaymentType] = useState({ id: 0, value: "" });
    const [paymentAmt, setPaymentAmt] = useState("");
    const [totalContractAmount, setTotalContractAmount] = useState(0)
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    dayjs.extend(customParseFormat);

    //Get Sale Info
    const { data: saleInfoData, refetch, isFetching } = useGetSaleInfoByIdQuery({ ProjectId: projectId })

    const formatNumber = (value: any) =>
        value ? Number(value).toFixed(2) : "0";
    const [remainingAmount, setRemainingAmount] = useState("0");
    const [remainingAmountFormatted, setRemainingAmountFormatted] = useState(0);

    const saleInfoSchema = Yup.object().shape({
        lst_SaleRepresentative: Yup.object().shape({
            id: Yup.string().required('Sale Representative ID is required'),
            value: Yup.string().required('Sale Representative value is required'),
        }),
        saleDate: Yup.string().required("Sale Date is required"),
    });

    const formik = useFormik({
        validationSchema: saleInfoSchema,
        initialValues: initialValuesSale,

        onSubmit: (values) => {
            // UpsertSaleInfo({ ...values, projectId: projectId });
        },

    });

    useEffect(() => {
        refetch()
    }, []);

    useEffect(() => {
        if (saleInfoData?.result && Object.keys(saleInfoData?.result).length > 0) {
            formik.setValues({ ...saleInfoData?.result });
        } else {
            // setUpdateId(0);
        }
    }, [saleInfoData]);

    useEffect(() => {
        const total = formik?.values?.projectPaymentSchedule?.reduce(
            (sum: any, item: any) => sum + (item?.newAmount || 0),
            0
        ) || 0;
        const formattedTotal = total.toFixed(2)
        // const totalAmount = formatNumber(total)
        formik.setFieldValue("totalPaymentAmt", formattedTotal);
        const remaining = formik?.values?.totalContractAmt - formattedTotal;
        const remainingFormatted = new Intl.NumberFormat("en-US").format(remaining);
        setRemainingAmount(remainingFormatted);
        setRemainingAmountFormatted(remaining)
        formik.setFieldValue("remainingAmount", remainingAmount);
    }, [formik.values, setRemainingAmount]);

    const handleTableChange = () => {
        // Check if payment type and amount are valid
        if (!paymentType.id && paymentAmt !== '0' || !paymentAmt) {
            alert("Please select a payment type and enter an amount.");
            return;
        }
        const maxOrderId = formik.values.projectPaymentSchedule.reduce(
            (max: number, entry: any) => Math.max(max, entry.orderId || 0),
            0
        );

        const newOrderId = maxOrderId + 1;

        // Create a new entry
        const newEntry = {
            id: crypto.randomUUID(),
            projectId: projectId,
            orderId: newOrderId,
            lst_PaymentType: paymentType,
            paymentAmt: parseFloat(paymentAmt),
            newAmount: parseFloat(paymentAmt),
            lst_CreatedBy: { id: 0, value: "" },
            lst_Modified: { id: 0, value: "" },
            createdDT: new Date().toISOString(),
            modifiedDT: new Date().toISOString(),
        };


        const filteredSchedule = formik.values.projectPaymentSchedule.filter(
            (entry) => entry.id !== "3fa85f64-5717-4562-b3fc-2c963f66afa6"
        );
        const updatedSchedule = [...filteredSchedule, newEntry]
        formik.setFieldValue("projectPaymentSchedule", updatedSchedule);

        setPaymentType({ id: 0, value: "" });
        setPaymentAmt("");
    };

    // useEffect(() => {
    //     formik.setFieldValue(
    //         "totalContractAmt",
    //         (Number(formik?.values?.salePrice) || 0) + (Number(formik?.values?.totalAdendum) || 0)
    //     );
    // }, [formik.values]);

    const handleSalePriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value.replace(/,/g, "");
        if (/^\d*$/.test(inputValue)) {
            formik.setFieldValue("salePrice", Number(inputValue));
        }
    };

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    const headers = [
        { label: "Payment Type", key: "lst_PaymentType" },
        { label: "Amount", key: "newAmount" }
    ];

    const csvData = formik.values?.projectPaymentSchedule?.map((item: any) => ({
        lst_PaymentType: item.lst_PaymentType?.value,
        newAmount: formatComma(item.newAmount ?? '0.0')
    })) || [];

    return (
        <>
            <div className='row'>
                <div className='col-md-8'>
                    {/* table  */}
                    <div className='card'>
                        <div className='card-body card-css'>

                            <div className='d-flex justify-content-end'>
                                <CSVLink data={csvData} headers={headers} filename={`Payment Schedule.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                                    <i className="fa fa-file-export" />
                                    Export To CSV
                                </CSVLink>
                            </div>
                            <div className="table-responsive mt-2 overflow-auto financialTableHeight">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Payment Type
                                            </th>
                                            <th className='text-end'>
                                                Payment Amt
                                            </th>
                                        </tr>
                                    </thead>
                                    {isFetching ?
                                        <tr>
                                            <td colSpan={5} className='text-center'>
                                                <TableLoading />
                                            </td>
                                        </tr>
                                        :
                                        <tbody>
                                            {formik?.values?.projectPaymentSchedule?.map((item: any, index: any) => (
                                                <tr key={item.id}>
                                                    <td >{item.lst_PaymentType?.value}</td>
                                                    <td className='text-end'>
                                                        <FormattedNumber value={item.newAmount} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-2 mt-2'>Payment Schedule</h5>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Sale Price
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.salePrice} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Total Addenda Amount
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalAdendum} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Total Contract Amount
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalContractAmt} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Total Payment Distribution
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalPaymentAmt} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12'></div>
                            <div className="col-md-12 mt-2 w-100 d-flex justify-content-end ">
                                <div className='br-gray py-2 px-3 w-50'>
                                    <p className='color-red fs-15 fw-600 text-end'> {<FormattedNumber value={remainingAmountFormatted} />}</p>
                                </div>

                            </div>
                            {parseFloat(remainingAmount.replace(/,/g, '')) < 0 && (
                                <p className="color-red fw-semibold d-flex justify-content-end">
                                    Negative amount not considered
                                </p>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default FinancialPayment